import React, { ReactNode } from "react";
import TableHead from "./TableHead";
import TableRow from "./TableRow";
import theme from "@/constants/theme";

interface ColumnProps {
  title: string;
  field: string;
  render?: (row: unknown) => ReactNode;
}

export interface TableProps {
  components?: { Action: React.FC<{ data: any }> };
  columns: ColumnProps[];
  data: Record<string, any>[];
}

const Table: React.FC<TableProps> = ({ columns, data, components }) => {
  return (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        color: theme.colors.text.body,
        border: "1px solid",
        borderColor: theme.colors.border,
        fontSize: 14,
        marginBottom: 16,
        borderRadius: 16,
      }}
    >
      <TableHead
        columns={columns}
        components={components}
      />
      <tbody>
        {data.map((row, index) => (
          <TableRow
            index={index}
            key={row.id}
            columns={columns}
            row={row}
            components={components}
          />
        ))}
      </tbody>
    </table>
  );
};

export default Table;
